//import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Help from './views/Help/Help.vue';
import HelpId from './views/Help/Help__id.vue';
import HelpListCadastral from './views/Help/HelpListCadastral';
import HelpListCommon from './views/Help/HelpListCommon';
import HelpListEdit from './views/Help/HelpListEdit';

import NewsId from './views/News/News__id';
import NewsBlog from './views/News/NewsBlog';
import NewsCommon from './views/News/NewsCommon';
import NewsLandPlan from './views/News/NewsLandPlan';
import NewsLayers from './views/News/NewsLayers';
import News from './views/News/News';
import ActualLandPlans from './views/News/ActualLandPlans';
import ActualLandPlanId from './views/News/ActualLandPlanId';

import Workshops from './views/Workshops/Workshops';
import WorkshopsId from './views/Workshops/Workshops__id';
import RequestWorkshop from './views/Workshops/RequestWorkshop';

import Solutions from './views/Solutions.vue';
import DataStore from './views/Solutions/DataStore';
import Organization from './views/Solutions/Organization';
import Professional from './views/Solutions/Professional';
import SmartMaps from './views/Solutions/SmartMaps';

import Pricing from './views/Pricing.vue';
import MapApp from './views/MapApp.vue';
import Favourite from './views/Favourite.vue'
import Page404 from './views/404';

import i18n from './i18n';
const routesSettings = require('../routes.json');
import store from './store/store';


export default (Vue) => {
  Vue.use(Router);

  const scrollBehavior = function (to, from, savedPosition) {
    const toName = to.name.split('__')[0];
    const fromName = from.name.split('__')[0];

    if (routesSettings && routesSettings.routeNoScrollReset) {
      const noResetScroll = routesSettings.routeNoScrollReset.find(conf => (conf.to === toName && conf.from === fromName));
      if (noResetScroll) {
        return savedPosition;
      }
    }

    if (savedPosition) {
      return  savedPosition;
    }

    if (to.hash) {
      return {selector: to.hash};
    }

    return {x: 0, y: 0};
  }

  function evaluateGuards(guards, to, from, next) {
    const guardsCopy = guards.slice(0);
    const nextGuard = guardsCopy.shift();

    if (nextGuard === undefined) {
        next();
        return;
    }

    nextGuard(to, from, (nextArg) => {
        //Stop processing next middlewares if nextArg value is present
        if (nextArg !== undefined) {
          return next(nextArg);
        }

        //Run next middleware
        evaluateGuards(guardsCopy, to, from, next);
        return;
    });
  }

  const guardsArray = (guards) => {
    return (to, from, next) => {
        return evaluateGuards(guards, to, from, next);
    };
  };

  const testNextGuard = (to, from, next) => {
    next();
  };

  const setLocaleBeforeRouteEnter = (to, from, next) => {
    const detectedLocale = routesSettings.languages.find(l => {
      const prefix = routesSettings.prefixes[l];
      return to.fullPath.startsWith(`${prefix}`) ? l: false;
    });

    if (i18n.locale !== detectedLocale) {
      i18n.locale = detectedLocale;
      store.commit('SET_LANG', detectedLocale);
    }

    if (Vue && Vue.prototype.axios) {
      const commonHeaders = Vue.prototype.axios.defaults.headers.common;
      if (commonHeaders && commonHeaders['Content-Language'] !== detectedLocale) {
        Vue.prototype.axios.defaults.headers.common = {
          "Content-Language": detectedLocale
        };
      }
    }

    next();
  };

  const generateLocaleRoutes = (routesArray, prefix, componentsDict, langAfix) => {
      const routes = [];
      prefix = prefix ? prefix : '';
      routesArray.map(r => {
          if (componentsDict[r.name]) {
              routes.push({
                  path: prefix + r.path,
                  // route level code-splitting
                  // this generates a separate chunk (about.[hash].js) for this route
                  // which is lazy-loaded when the route is visited.
                  //component: () => import('./view/About-lazy.vue')
                  component: componentsDict[r.name],
                  name: langAfix ? r.name + '__' + langAfix : r.name,
                  beforeEnter: guardsArray([
                    setLocaleBeforeRouteEnter,
                    testNextGuard
                  ])
              });
          }
      });
    return routes;
  };

  const processRoutesSetting = settings => {
      let routes = [];
      settings.languages.map(lang => {
          const routesArray = settings.locales[lang];
          if (routesArray) {
              const newRoutes = generateLocaleRoutes(
                  routesArray,
                  //(settings.defaultLanguage === lang && settings.defaultLanguageHidePrefix) ? '' :  settings.prefixes[lang],
                  settings.prefixes[lang],
                  routeNameComponent,
                  lang
              );

              routes = [
                  ...routes,
                  ...newRoutes
              ];
          }
      });

      return routes;
  };

  const routeNameComponent = {
    "solutions": Solutions,
    "solutions_datastore": DataStore,
    "solutions_organization": Organization,
    "solutions_professional": Professional,
    "solutions_smartmaps": SmartMaps,
    "favourite": Favourite,
    "home": Home,
    "help": Help,
    "help_id": HelpId,
    "helpListCadastral": HelpListCadastral,
    "helpListCommon": HelpListCommon,
    "helpListEdit": HelpListEdit,
    "pricing": Pricing,
    "news": News,
    "news_id": NewsId,
    "news_blog": NewsBlog,
    "news_common": NewsCommon,
    "news_landplan": NewsLandPlan,
    "news_actual_landplans": ActualLandPlans,
    "news_actual_landplans_region": ActualLandPlans,
    "news_actual_landplans_region_district": ActualLandPlans,
    "news_actual_landplans_region_district_city": ActualLandPlanId,
    "news_layers": NewsLayers,
    "workshops_request_workshop": RequestWorkshop,
    "workshops": Workshops,
    "workshops_id": WorkshopsId,
    "index": MapApp,
    '*': Page404
  };

  const routes = [
    ...processRoutesSetting(routesSettings),
    {path: "/", name: "mapApp", component: MapApp},
    {path: "/#map", name: "mapAppHash", component: MapApp},
    {path: "*", name: "*", component: Page404}
  ];

  //console.log('ROUTES: ', routes);

  return new Router({
      mode: 'history',
      base: process.env.BASE_URL,
      scrollBehavior,
      routes,
      fallback: false
  });
};


export const createEventBusManager = ($$, router, vueApp) => {
  // eslint-disable-next-line
  $$('routingInitialization', 'memory').listen(callback => {
    callback(router, vueApp);
  });

  return {
    fireUpdate: (to, from, next) => {
      // eslint-disable-next-line
      $$('routeUpdated', 'memory').fire({to, from, next});
    }
  }
};



